import React, { useRef, useState, useEffect } from 'react';
import { useRecoilState } from 'recoil';
import { languageState } from '../../recoil/language/languageAtom';
import i18n from 'locales/i18n';

const LanguageToggleButtonGroup = () => {
  const [languageToggleShow, setLanguageToggleShow] = useState(false);
  const toggleLangButtonRef = useRef();
  const [language, setLanguage] = useRecoilState(languageState);

  const changeLanguage = (newLanguage) => {
    setLanguage(newLanguage);
    setLanguageToggleShow(false);
    localStorage.setItem('selectedLanguage', newLanguage);
    i18n.changeLanguage(newLanguage);
    window.location.reload(); // 페이지 새로고침(locale에 따라 api response가 바뀌기 때문에 설정)
  };

  const handleToggleLanguage = () => {
    setLanguageToggleShow(!languageToggleShow);
  };

  const handleClickOutside = (event) => {
    // 클릭된 요소가 토글 버튼의 자식이 아니면서 토글 버튼이 열려있을 때
    if (toggleLangButtonRef.current && !toggleLangButtonRef.current.contains(event.target) && languageToggleShow) {
      setLanguageToggleShow(false);
    }
  };

  useEffect(() => {
    // 마운트될 때 이벤트 리스너 추가
    document.addEventListener('mousedown', handleClickOutside);

    // 언마운트될 때 이벤트 리스너 정리
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [languageToggleShow]);

  useEffect(() => {
    const selectedLanguage = localStorage.getItem('selectedLanguage');
    if (selectedLanguage) {
      setLanguage(selectedLanguage);
    }
  }, [language]);

  return (
    <div
      className={`toggle-button-group type-language ${languageToggleShow ? 'is-active' : ''}`}
      ref={toggleLangButtonRef}
    >
      <button
        type={'button'}
        className={'button-default language-toggle-button'}
        onClick={() => {
          handleToggleLanguage();
        }}
      >
        <i className={'icon icon-language'} />
        <span className={'language-txt'}>{language.toUpperCase()}</span>
      </button>
      <div className={'toggle-content-wrapper'}>
        <ul className={'toggle-content-group'}>
          <li className={'toggle-content-list'}>
            <button
              type={'button'}
              className={'button-default toggle-content-button'}
              onClick={() => {
                changeLanguage('en');
              }}
            >
              English
            </button>
          </li>
          <li className={'toggle-content-list'}>
            <button
              type={'button'}
              className={'button-default toggle-content-button'}
              onClick={() => {
                changeLanguage('ko');
              }}
            >
              한국어
            </button>
          </li>
          <li className={'toggle-content-list'}>
            <button
              type={'button'}
              className={'button-default toggle-content-button'}
              onClick={() => {
                changeLanguage('jp');
              }}
            >
              日本語
            </button>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default LanguageToggleButtonGroup;
